var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiskIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "disk 1",
    clipPath: "url(#clip0_217_1601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.341 2.1664L9.83351 0.659395C9.41266 0.235715 8.83966 -0.00180064 8.2425 -0.000113139H2.25C1.00793 0.00126967 0.00138281 1.00782 0 2.24989V9.74989C0.00138281 10.992 1.00793 11.9985 2.25 11.9999H9.75C10.9921 11.9985 11.9986 10.992 12 9.74989V3.75739C12.0017 3.16032 11.7644 2.58739 11.341 2.1664ZM10.5 9.74989C10.5 10.1641 10.1642 10.4999 9.75 10.4999H2.25C1.83579 10.4999 1.5 10.1641 1.5 9.74989V2.24989C1.5 1.83568 1.83579 1.49989 2.25 1.49989H3C3 2.60445 3.89543 3.49988 4.99999 3.49988H6.49999C7.58491 3.49772 8.47027 2.631 8.49549 1.54639C8.59955 1.58272 8.69419 1.6418 8.77249 1.71938L10.2805 3.22737C10.4215 3.36767 10.5005 3.5585 10.5 3.75736V9.74989H10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.99999 8.99998C7.10456 8.99998 7.99998 8.10456 7.99998 6.99999C7.99998 5.89543 7.10456 5 5.99999 5C4.89543 5 4 5.89543 4 6.99999C4 8.10456 4.89543 8.99998 5.99999 8.99998Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_1601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskIcon);
export default __webpack_public_path__ + "static/media/diskIcon.26394f5526b475e290f5382dc9dcee52.svg";
export { ForwardRef as ReactComponent };